
// --- Nhận diện khách đến từ quảng cáo (thêm 26/08/2026) ---
// Khách bấm từ ads vào là để xem sản phẩm; chặn họ bằng popup làm mất đơn.
const NP_AD_PARAMS = ['fbclid', 'gclid', 'ttclid', 'msclkid', 'twclid', 'utm_id'];

function npFromAds() {
  try {
    if (sessionStorage.getItem('np-from-ads') === '1') return true;
    const p = new URLSearchParams(window.location.search);
    let hit = NP_AD_PARAMS.some((k) => p.has(k));
    const medium = (p.get('utm_medium') || '').toLowerCase();
    const source = (p.get('utm_source') || '').toLowerCase();
    if (!hit && /paid|cpc|ppc|^ads?$|social_paid/.test(medium)) hit = true;
    if (!hit && /facebook|instagram|meta|tiktok|google|^fb|^ig/.test(source)) hit = true;
    if (!hit && /facebook\.com|instagram\.com|fb\.com|fb\.me/.test(document.referrer || '')) hit = true;
    if (hit) sessionStorage.setItem('np-from-ads', '1');
    return hit;
  } catch (e) {
    return false;
  }
}

class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.np__dialog');
    this.form = this.querySelector('form');
    this.key = 'np-dismissed';
    this.days = 14;

    // If the form was just submitted successfully, open immediately and mark done.
    if (this.querySelector('.np__success')) {
      this.open();
      this.remember();
      this.bindClose();
      return;
    }

    if (this.dismissed()) return;
    if (npFromAds()) return; // đến từ quảng cáo -> không làm phiền

    const delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
    this.timer = setTimeout(() => this.open(), delay);

    // Exit intent on desktop: mouse leaves the top of the viewport.
    this.onLeave = (e) => {
      if (e.clientY <= 0) this.open();
    };
    document.addEventListener('mouseout', this.onLeave);

    this.bindClose();
  }

  bindClose() {
    this.querySelectorAll('[data-np-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    // Bấm ra vùng nền ngoài hộp thoại cũng đóng - phản xạ đầu tiên của phần lớn người dùng.
    this.addEventListener('click', (e) => {
      if (this.dialog && !this.dialog.contains(e.target)) this.close();
    });
    this.onKey = (e) => {
      if (e.key === 'Escape') this.close();
    };
  }

  open() {
    if (this.isOpen || this.dismissed()) return;
    this.isOpen = true;
    clearTimeout(this.timer);
    document.removeEventListener('mouseout', this.onLeave);
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.addEventListener('keydown', this.onKey);
    const input = this.querySelector('input[type="email"]');
    if (input) setTimeout(() => input.focus(), 300);
  }

  close() {
    this.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKey);
    this.remember();
    setTimeout(() => {
      this.hidden = true;
      this.isOpen = false;
    }, 300);
  }

  remember() {
    try {
      const until = Date.now() + this.days * 86400000;
      localStorage.setItem(this.key, String(until));
    } catch (e) {}
  }

  dismissed() {
    try {
      const until = parseInt(localStorage.getItem(this.key), 10);
      return until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    document.removeEventListener('mouseout', this.onLeave);
    document.removeEventListener('keydown', this.onKey);
  }
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup);
}
